export default "__VITE_ASSET__ga3Fwkq6__"